import { HttpErrorResponse, HttpStatusCode } from "@angular/common/http";
import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { IUserDto } from "moo-shared";
import { catchError, of } from "rxjs";
import { IpTokenService } from "../../../../core/authentication/iptoken.service";
import { ResourceApiService } from "../../../../core/authentication/resource-api.service";
import { LoginService } from "../../../../features/login/login.service";
import { ILoginPageQueryparameters, PageMode, toSnakeCase } from "../../../../features/login/query-params.model";
import { routePaths } from "../../../../routes";
import { BaseComponent } from "../../../../shared/base.component";
import { isEmptyString } from "../../../../shared/helpers";
import { ButtonTile } from "../../../../shared/models/button-tile.model";
import { ITile } from "../../../../shared/models/tile.model";
import { UserTile } from "../../../../shared/models/user-tile.model";
import { LoginAssistantService } from "../../login-assistant.service";

@Component({
  selector: "app-group-details",
  templateUrl: "./group-details.component.html",
  styleUrls: ["./group-details.component.scss"]
})
export class GroupDetailsComponent extends BaseComponent {
  override componentTranslationRoot = "login-assistant.group-details";
  userTiles: ITile[] = [];
  groupName = "";

  constructor(
    translateService: TranslateService,
    private router: Router,
    private resourceApiService: ResourceApiService,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private readonly loginAssistantService: LoginAssistantService,
    private readonly ipTokenService: IpTokenService) {
    super(translateService);
  }

  ngOnInit(): void {
    this.subscriptionsToRelease.push(
      this.route.data.subscribe(({ users }) => {
        this.setGroupData(users);
      })
    );
  }

  setGroupData(users: IUserDto[]) {
    this.groupName = this.loginAssistantService.selectedGroup!.name;
    const maskNames = this.ipTokenService.hasMultipleOrganisations();
    this.userTiles = users.map(user => maskNames ? UserTile.fromDtoMasked(user) : UserTile.fromDto(user));
    this.userTiles.forEach(user => this.getUserPicture(user));
    this.userTiles.sort((a, b) => a.name.localeCompare(b.name));

    this.userTiles.unshift(ButtonTile.createBackTile(this.translate("back-to-groups")));
  }

  getUserPicture(user: ITile) {
    this.resourceApiService.getUserPicture(user.key).subscribe((data) => {
      if (!isEmptyString(data)) {
        const urlCreator = window.URL || window.webkitURL;
        const imageUrl = urlCreator.createObjectURL(data);
        user.picture = imageUrl;
      }
    });
  }

  loginWithUser(user: ITile) {
    if (user.key === ButtonTile.BackTileKey) {
      this.loginAssistantService.clearGroup();
      this.router.navigate([`/${routePaths.loginAssistant}/${routePaths.groups}`]);
    } else {
      this.loginService.checkLoginUrl((user as UserTile).loginName)
        .pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === HttpStatusCode.NotFound) {
              const pageParams: ILoginPageQueryparameters = {
                LoginHint: (user as UserTile).loginName,
                PageMode: PageMode.Password
              };
              this.router.navigate(["/"], {
                queryParams: toSnakeCase(pageParams)
              });
            }
            //if there will be other error then  404 its job of an interceptor to show an error somewhere (dev not yet done)
            return (of({}));
          })
        )
        .subscribe();
    }
  }
}
